import "./NoPaymentsView.scss";
import { Text } from "@mantine/core";
import PaymentButtons from "../../PaymentButtons/PaymentButtons";
import { AppResources } from "@/constants.ts";

interface NoPaymentsView {
  isOwner?: boolean;
}

const NoPaymentsView = ({ isOwner }: NoPaymentsView) => {
  const noPaymentImage = AppResources.noPayments;

  const titleMessage = isOwner ? "No payments yet" : "No payment requests yet.";
  const bodyMessage = isOwner ? (
    <>
      Looks like you haven’t requested any payments yet.
      <br />
      Once you start requesting payments from clients, <br />
      you’ll be able to track them all here.
    </>
  ) : (
    ""
  );

  return (
    <div className="no-payments-view">
      <img src={noPaymentImage} alt="No Payments" />
      <div className="no-payments-view-text">
        <h2>{titleMessage}</h2>
        <Text>{bodyMessage}</Text>
      </div>
      {isOwner && <PaymentButtons showDashboardButton={false} />}
    </div>
  );
};

export default NoPaymentsView;
